import { cva } from "cva";

export const carouselStyles = cva({
  base: "relative flex flex-col gap-y-32 w-full max-w-[100vw] overflow-visible cursor-grab active:cursor-grabbing",
});

export const carouselWrapperStyles = cva({
  base: "relative w-full max-w-[100vw] overflow-visible py-10",
});

export const carouselContainerStyles = cva({
  base: "flex will-change-transform",
  variants: {
    loop: {
      true: "",
      false: "",
    },
  },
});
